module.exports = __webpack_public_path__ + "static/perla-13266b8e95518d9c17fe5a7b42516cb2.png";